import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TeamService } from 'src/app/private/services/teams.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { TrackingService } from 'src/app/private/services/tracking.service';

@Component({
  selector: 'app-create-team',
  templateUrl: './create-team.component.html',
  styleUrls: ['./create-team.component.scss']
})
export class CreateTeamComponent {
  @Input() formAction: any;
  @Output() close = new EventEmitter();
  btnLoading = false;
  @Input() selectedUsers: any[] = [];
  @Output() reload = new EventEmitter();

  teamname: any;
  @Input() users: any[] = [];
  selectedItems: any[] = [];

  constructor(
    private localstorage: LocalStorageService,
    private api : TeamService,
    private toaster: ToastrService,
    private tracker: TrackingService,

  ) { }

  ngOnInit() {
    this.users = this.users.map((user: any) => ({
      item_id: user.user_id,
      item_text: user.fname + ' ' + user.lname,
    }));
  }


  dropdownSettings = {
    singleSelection: false,
    idField: 'item_id',
    textField: 'item_text',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };

  closeModal() {
    this.close.emit();
  }

  saveTeam(isValid: any): void {
    if (isValid) {
    
        const payload = {
          client_id: this.localstorage.getClientId(),
          name: this.teamname,
          manager_id: this.localstorage.getUserId(),
          user_id: this.selectedItems.map((item) => item.item_id),
        };

        this.btnLoading = true;

        this.api.createTeam(payload).subscribe({
          next: (res) => {
            this.btnLoading = false;
            this.toaster.success(res.message || 'Team Created Successfully');
            this.tracker.track(
  "Create",
  "Team",
  `Team created: ${payload.name} with users: ${payload.user_id.join(', ')}`
);

            this.reload.emit();
            this.close.emit();
          }
          , error: (err) => {
            this.btnLoading = false;
            this.close.emit();
            this.toaster.error(err.error.message || 'Something went wrong');
          }
        });
    
    }
  }
}
